import { Typography } from "@atoms/typography";
import React, { FC } from "react";
import { Trans } from "next-i18next";
import styled from "styled-components";
import { Price } from "@atoms/price";

export type BookingPriceResultProps = {
  price: number | null;
  nights?: number;
};

export const BookingPriceResult: FC<BookingPriceResultProps> = ({
  price,
  nights,
}) => {
  return price && nights ? (
    <Container>
      <Typography variant="body1">
        Your final price for <b>{nights} nigths</b> is:
      </Typography>
      <Typography variant="title2">
        {price ? (
          <Price amount={price} />
        ) : (
          <Trans>Fill in the form to find out.</Trans>
        )}
      </Typography>
    </Container>
  ) : null;
};

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin: 0;
  }
  h2 {
    margin: 0;
    font-weight: 800;
    font-size: 1.2rem;
  }
`;
